export const socketUpdate = {
    methods: {
        'wallet/money-in-out-short-update': function (data) {
            if (this.autoUpdate === -1) {
                return
            }

            let moneyData = JSON.parse(data)

            if (!Array.isArray(moneyData.data)) moneyData.data = [ moneyData.data ]

            if (!this.autoUpdate) {
                this.pausedItems = this.pausedItems.concat(moneyData.data)
                return
            }

            if (!this.additionalItems) {
                this.$set(this, 'additionalItems', [])
            }
            this.additionalItems = moneyData.data
        },

        leaveRooms () {
            this.options?.socketUpdate?.subscriptions?.forEach((event) => {
                this.socket.emit('leaveRoom', { eventName: event })
                this.socket.off(event, this[event])
            })
        },

        joinRooms () {
            this.options?.socketUpdate?.subscriptions?.forEach?.((event) => {
                this.socket?.emit?.('joinRoom', { eventName: event })
                this.socket?.on?.(event, this[event])
            })
        },
    },
}
